module.exports = __webpack_public_path__ + "img/Weapon_180.1d57386d.png";